import React from "react";
import { Alert, AlertIcon } from "@chakra-ui/react";

const RiskReviewRuleEditor = () => (
  <Alert status="info" borderRadius="md">
    <AlertIcon />
    Visual rule editing will be enabled after template mutation requirements are finalized.
  </Alert>
);

export default RiskReviewRuleEditor;
